import { Component } from '@angular/core';
import { SettingsService } from "../../_services/settings.service";
import { AlertService } from "../../_services/alert.service";
import { ItemMap } from "../../_models/crmStats";


@Component({
  selector: 'ifitems',
  templateUrl: 'items.html'
})

export class ItemsComponent {

  items: ItemMap[] = [];
 
  constructor(public settings: SettingsService,
    private alert: AlertService) {
    let scope = this;
    

    settings.getItems().subscribe((data:ItemMap[] ) => {
      scope.items = data;
    });

  }
  edit(item:ItemMap) {
    if (item.edit) {
      if (item.CRMLeadType == "" && item.XeroItemCode == "") {
        this.alert.error("Both fields needed please");
      }
      else {
        item.edit = false;
        this.settings.updateItem(item).subscribe((res) => {
          console.log(res);
        });
      }
    }
    else {
      item.tempCRM = item.CRMLeadType;
      item.tempXero = item.XeroItemCode;
      item.tempVat = item.VATRate;
      item.edit = true;
    }
  }
  cancelItem(item:ItemMap) {
    item.CRMLeadType = item.tempCRM;
    item.XeroItemCode = item.tempXero;
    item.VATRate = item.tempVat;
    item.edit = false;
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/items/items.ts